"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetProfileDetailSchema = exports.AssetProfilePageSchema = exports.AttachmentSchema = exports.AdditionalContentSchema = exports.MainDisplaySchema = void 0;
const zod_1 = require("zod");
/**
 * Asset Profile Page related types, taken from Product types
 * TODO: Probably could combine the types here with the Product types
 */
exports.MainDisplaySchema = zod_1.z.object({
    item: zod_1.z.enum(['video', 'image', '']),
    url: zod_1.z.string(),
    permitNumber: zod_1.z.string(),
    species: zod_1.z.string(),
    strain: zod_1.z.string(),
    subStrain: zod_1.z.string(),
});
exports.AdditionalContentSchema = zod_1.z.object({
    subheading: zod_1.z.string(),
    content: zod_1.z.string(),
});
exports.AttachmentSchema = zod_1.z.object({
    title: zod_1.z.string(),
    url: zod_1.z.string(), // URL after uploading to s3
});
exports.AssetProfilePageSchema = zod_1.z.object({
    mainDisplay: exports.MainDisplaySchema,
    content: zod_1.z.array(exports.AdditionalContentSchema),
    attachment: zod_1.z.array(exports.AttachmentSchema),
});
// Asset Profile
exports.AssetProfileDetailSchema = zod_1.z.object({
    assetName: zod_1.z.string(),
    createdBy: zod_1.z.string().optional(),
    archived: zod_1.z.boolean(),
    mainDisplay: exports.MainDisplaySchema,
    content: zod_1.z.array(exports.AdditionalContentSchema),
    attachment: zod_1.z.array(exports.AttachmentSchema),
});
